function getQuestionType(question) {
    if (question.dragAndDrop) {
        return 'DRAG_AND_DROP';
    } else if (question.range) {
        return 'RANGE';
    } else if (question.options) {
        return question.options.length > 0 ? 'CHOOSE_ONE' : 'TEXT';
    } else if (question.multiOptions) {
        return 'MULTI_OPTION';
    } else {
        return 'UNDEFINED'
    }
}

function isMeasurableDimension(dimension){
    return dimension !== 'Perfil';
}

function getQuestionObj(questions, answers, order) {
    const question = questions.find(q => q.order === order);
    if (!question) {
        return { error: `Questao [${order}] nao encontrada` }
    }
    const a = answers.find(a => a.order === order);
    if (!a) {
        return { error: `Resposta [${order}] nao encontrada` }
    }

    let answer = '';
    switch (a.type) {
        case 'CHOOSE_ONE':
            answer = question.options.find(o => o.value === a.answer).title;
            break;
        case 'MULTI_OPTION':
        case 'DRAG_AND_DROP':
            answer = a.answer.join(' | ');
            break;
        default:
            answer = a.answer;
    }

    return { order, title: question.title, answer }
}

function getTotalObj(stepTitle, dimensionTitle, allQuestions, answers) {
    const total = getAnswerTotal(allQuestions, answers.filter(a => stepTitle ? a.stepTitle === stepTitle : (a.dimension === dimensionTitle && !a.question.pass)));
    const possible_total = getQuestionsWithValues(answers.filter(a => stepTitle ? a.stepTitle === stepTitle : (a.dimension === dimensionTitle && !a.question.pass))).length;
    return { title: stepTitle || dimensionTitle, total, outOf: possible_total, percentage: possible_total && Math.trunc((100 * total) / possible_total) }
}

function getQuestionsWithValues(answers) {
    return answers.filter(a => {
        return ['CHOOSE_ONE', 'RANGE', 'MULTI_OPTION'].includes(a.type);
    }).map(a => a.question);
}

function getAnswerTotal(allQuestions, answers) {
    const total = answers.reduce((total, a) => {
        if (!isMeasurableDimension(a.dimension)) {
            return total;
        }
        switch (a.type) {
            case 'CHOOSE_ONE':
                return total + a.answer;
            case 'RANGE':
                return total + (a.answer * 0.1);
            case 'MULTI_OPTION':
                const question = allQuestions.find(q => q.order === a.order);
                return total + a.answer.reduce((subtotal, checkboxCaption) => {
                    const option = question.multiOptions.find(o => o.title === checkboxCaption)
                    return subtotal + option.value;
                }, 0);
            default:
                return total;
        }
    }, 0);
    return total.toFixed(2);
}

export { getQuestionType, getQuestionObj, getTotalObj, isMeasurableDimension }